import {Component, forwardRef, Input, OnDestroy, OnInit} from '@angular/core';
import {ControlValueAccessor, FormControl, FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR} from '@angular/forms';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {IoniconsOutline, WidgetValidator} from '@pt/pt-models';
import {WidgetTreatmentDataInterestedV0Response} from '../models/widget-treatment-data-interested-v0-response';
import {WidgetUtils} from '../../../widget.utils';
import {ValidatorGenerator} from '../../../../utils/validator-generator';

@Component({
  selector: 'pt-widget-treatment-data-interested-v0-list-checkbox',
  templateUrl: './widget-treatment-data-interested-v0-list-checkbox.component.html',
  styleUrls: ['./widget-treatment-data-interested-v0-list-checkbox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => WidgetTreatmentDataInterestedV0ListCheckboxComponent)
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => WidgetTreatmentDataInterestedV0ListCheckboxComponent),
      multi: true
    }
  ]
})
export class WidgetTreatmentDataInterestedV0ListCheckboxComponent implements OnInit, OnDestroy, ControlValueAccessor {

  @Input() id;
  @Input() controlName: string;
  @Input() title: string;
  @Input() checkboxs: WidgetTreatmentDataInterestedV0Response[];
  @Input() validators: WidgetValidator[];
  @Input() preview: boolean;

  internalId = WidgetUtils.generateId('wtdiv0_');
  checkboxPreview: WidgetTreatmentDataInterestedV0Response[];

  loading = false;
  IconDoubleCheck = IoniconsOutline.doubleCheck;
  IconCheck = IoniconsOutline.check;
  IconClose = IoniconsOutline.close;

  public formGroup: FormGroup;
  isChangedValue = false;
  private destroy$: Subject<boolean> = new Subject<boolean>();
  private onChanged: (val) => void;
  private onTouched: () => void;

  ngOnDestroy(): void {
    this.destroy$.next(true);
  }

  ngOnInit(): void {
    this.setFormGroup();

    this.formGroup.valueChanges.pipe(
      takeUntil(this.destroy$)
    ).subscribe(t => {
      this.isChangedValue = t !== null;
      const checkedUUID = this.getListCheckedUUID(t);
      if (this.onChanged) {
        this.onChanged(checkedUUID);
      }
      if (this.onTouched) {
        this.onTouched();
      }
    });

    this.checkboxPreview = this.checkboxs?.filter((c) => c.checked);
  }

  writeValue(obj: string[]): void {
    // this.formGroup.controls.value.setValue(obj);
  }

  registerOnChange(fn: any): void {
    this.onChanged = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (this.formGroup) {
      if (isDisabled) {
        this.formGroup.disable();
      } else {
        this.formGroup.enable();
      }
    }
  }

  validate(value: FormControl) {
    return this.formGroup.invalid && {
      invalid: true
    };
  }

  private getListCheckedUUID(t) {
    const response: string[] = [];
    Object.keys(t)?.forEach((k) => {
      if (t[k]) {
        response.push(k);
      }
    });
    return response;
  }

  private setFormGroup() {
    this.loading = true;
    const validator = ValidatorGenerator.generateFromGroupValidator(this.validators);
    this.formGroup = new FormGroup({}, validator);
    this.checkboxs?.forEach(v => {
      if (v.uuid) {
        this.formGroup.addControl(v.uuid, new FormControl(v.checked));
      }
    });
    this.loading = false;
  }

}
